/** DUPスコープ定義 */
export const DUP_SCOPE = {
  dupUserManagement: 'dupUserManagement',
  dupOrgUserManagement: 'dupOrgUserManagement',
  dupAeroUpload: 'dupAeroUpload',
  dupPropscrUpload: 'dupPropscrUpload'
} as const

/** アクションタイプ */
export const ACTION_TYPE = {
  read: 'R',
  write: 'W'
} as const
